<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col >
            <v-card v-for="(item, index) in staff" :key="index" flat>
              <v-card-title class="subtitle-2 font-weight-bold mt-0 pa-0 justify-center"> <span v-if="item.assistant == 0">{{item.duty}}</span><span v-else>{{item.duty + ' (Assistant)'}}</span></v-card-title>
              <v-card-subtitle class="mt-0 pa-0 text-center"><span class="font-weight-bold subtitle-2">{{item.contact + ' - (' + item.capid + ')'}}</span></v-card-subtitle>
              <div class="text-center mx-auto">
                <div style="display: inline-block; text-align: left;">
                  <v-card-text>
                    <br />
                    <label><span class="font-weight-bold">Appointed On: </span>{{item.dutysince}}</label><br />
                    <label><span class="font-weight-bold">Email: </span>{{item.email}}</label><br />
                    <div v-if="item.homephonevisible == true">
                      <span  class="font-weight-bold">Home Phone: </span>
                      <label> {{item.homephone.slice(0,3) + '-' + item.homephone.slice(3, 6) + '-' + item.homephone.slice(6)}}</label>
                    </div>
                    <div v-if="item.cellphonevisible == true">
                      <span class="font-weight-bold">Cell Phone: </span>
                      <label> {{item.cellphone.slice(0,3) + '-' + item.cellphone.slice(3, 6) + '-' + item.cellphone.slice(6)}}</label>
                    </div>
                    <br />
                    <div class="text-center">
                        <v-btn v-if="item.homephonevisible == true" class="mx-2" fab dark small color="blue darken-4" :href="`tel:+1${item.homephone}`">
                          <v-icon dark>mdi-phone</v-icon>
                        </v-btn>
                        <v-btn v-if="item.cellphonevisible == true" class="mx-2" fab dark small color="green darken-4" :href="`tel:+1${item.cellphone}`">
                          <v-icon dark>mdi-cellphone</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${item.email}`">
                          <v-icon dark>mdi-email</v-icon>
                        </v-btn>
                    </div>
                    <br />
                    <v-divider :key="item.capid"></v-divider>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>      
</template>

<script>
export default {
  name: 'StaffDirectoryStaff',
  props: {
    groupId: {
      type: String,
      default: null
    },
    orgId: {
        default: null
    },
    dutyName: {
        type: String,
        default: null
    }
  },
  components: {
  },
  data() {
    return {
      isLoading: false,
      staff: []
    }
  },
  mounted() {
    this.getStaffForUnitDutyPosition();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getStaffForUnitDutyPosition() {

      this.isLoading = true;

      var obj = {
          wing: this.selWing,
          orgid: parseInt(this.orgId),
          duty: this.dutyName
      }

      this.$https.post(this.$vars.BaseUrl + this.$vars.GetStaffForUnitDutyPositionRoute, obj, this.$vars.config)
        .then(response => {
          //console.log(response.data);
          this.httpResponse = response;
          this.staff = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });

    }
  }
}
</script>

<style>
  .listItem {
    height:30px;
  }

</style>
